import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ja: {
    translation: {
      header: {
        company: '企業理念',
        greeting: '挨拶',
        companyInfo: '会社情報',
        contact: 'お問い合わせ',
        recruitment: '責任者人員配置',
        privacy: '個人情報保護方針',
        offices: '営業所',
      },
      footer: {
        privacy: '個人情報保護方針',
        copyright: '© 2024 Presage Corporation. All rights reserved.',
      },
      buttons: {
        learnMore: '詳しく見る',
        contactUs: 'お問い合わせ',
        backToHome: 'ホームに戻る',
        apply: '応募する',
        submit: '送信',
        login: 'ログイン',
        logout: 'ログアウト',
      },
      home: {
        hero: {
          title: '株式会社プレサージュ',
          subtitle: 'より良いこれからを創造する会社です。',
          cta1: '詳しく見る',
          cta2: 'お問い合わせ',
        },
        news: {
          title: 'ニュース',
          viewAll: 'すべてのニュースを見る',
        },
      },
      contact: {
        title: 'お問い合わせ',
        name: 'お名前',
        email: 'メールアドレス',
        message: 'メッセージ',
        send: '送信',
      },
      recruitment: {
        title: '責任者人員配置',
        positions: '募集職種',
      },
      admin: {
        dashboard: '管理画面',
        news: 'ニュース管理',
        menu: 'メニュー管理',
        applications: '応募管理',
        recruitment: '採用情報',
        offices: '事業内容',
        company: '会社情報',
        editMode: '編集モード',
        create: '新規作成',
        edit: '編集',
        delete: '削除',
        save: '保存',
        cancel: 'キャンセル',
        translationHelper: '翻訳支援',
      },
      language: {
        japanese: '日本語',
        english: 'English',
      },
    },
  },
  en: {
    translation: {
      header: {
        company: 'Company Philosophy',
        greeting: 'Greeting',
        companyInfo: 'Company Info',
        contact: 'Contact Us',
        recruitment: 'Recruitment',
        privacy: 'Privacy Policy',
        offices: 'Offices',
      },
      footer: {
        privacy: 'Privacy Policy',
        copyright: '© 2024 Presage Corporation. All rights reserved.',
      },
      buttons: {
        learnMore: 'Learn More',
        contactUs: 'Contact Us',
        backToHome: 'Back to Home',
        apply: 'Apply Now',
        submit: 'Submit',
        login: 'Login',
        logout: 'Logout',
      },
      home: {
        hero: {
          title: 'Presage Corporation',
          subtitle: 'Creating a better future together.',
          cta1: 'Learn More',
          cta2: 'Contact Us',
        },
        news: {
          title: 'News',
          viewAll: 'View All News',
        },
      },
      contact: {
        title: 'Contact Us',
        name: 'Name',
        email: 'Email Address',
        message: 'Message',
        send: 'Send',
      },
      recruitment: {
        title: 'Recruitment',
        positions: 'Open Positions',
      },
      admin: {
        dashboard: 'Dashboard',
        news: 'News Management',
        menu: 'Menu Management',
        applications: 'Applications',
        recruitment: 'Recruitment',
        offices: 'Offices',
        company: 'Company Info',
        editMode: 'Edit Mode',
        create: 'Create New',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        translationHelper: 'Translation Helper',
      },
      language: {
        japanese: '日本語',
        english: 'English',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ja',
    fallbackLng: 'ja',
    supportedLngs: ['ja', 'en'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    debug: false,
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
    },
  });

export default i18n;
